import React from "react";
import { ExtractionContext } from "./extraction-context-props";

const useExtractionContext = () => {
    const context = React.useContext(ExtractionContext);
    if (context === undefined) {
        throw new Error('useExtractionContext must be used within an ExtractionProvider');
    }
    return context;
};

export default useExtractionContext;